export const getHrefFromBlob = (data: Blob, mimetype: string) => {
	if (data) {
		const blob = new Blob([data], { type: mimetype });
		return window.URL.createObjectURL(blob);
	}
};
